module.exports = __webpack_public_path__ + "img/geekvape.6aef6767.png";